"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const LabeledInputFieldWithImageWidget_1 = tslib_1.__importDefault(require("./LabeledInputFieldWithImageWidget"));
const KeyCode = tslib_1.__importStar(require("../util/KeyboardEventCodes"));
const StyledButton_1 = tslib_1.__importDefault(require("../buttons/StyledButton"));
const DropdownUtil_1 = tslib_1.__importDefault(require("../dropdown/DropdownUtil"));
const FieldSize_1 = require("../types/FieldSize");
const ImageWidget_1 = tslib_1.__importDefault(require("./ImageWidget"));
// Component rendered in the user interface
// <div role="combobox" aria-controls="list-box" aria-haspopup="listbox" class="auto-suggest-container">
//   <label for="input-id">label-text</label>
//   <div>
//      <div>
//          <div>
//              <src="/fmk/styles/images/search.svg" alt="Søg">
//              <input id="input-id"
//                  autocomplete="off"
//                  spellcheck="false"
//                  aria-autocomplete="list"
//                  type="text"
//                  placeholder="Søg">
//          </div>
//          <ul id="list-box" role="listbox" class="auto-suggest-menu">
//              <li role="option"></li>
//              ...
//          </ul>
//      </div>
//      <button>Nulstil</button>
//   </div>
// </div>
class LabeledSearchFieldWidget extends LabeledInputFieldWithImageWidget_1.default {
    constructor(args) {
        super({
            ...args,
            imageAlt: "",
            imageSrc: fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.SEARCH),
            placeholder: args.placeholder || "Søg...",
            updateOnInputChange: false
        });
        this.suggestions = [];
        this.suggestionsElements = [];
        this.optionToIndexMap = new Map();
        this.scrollListener = () => {
            this.renderTopOrBottom();
        };
        const { isSuggestionFormatHtml = false, minQueryLength = 2, showSuggestionsOnSearchFieldClick, searchInitially = false } = args;
        this.currentSelectionIndex = -1;
        this.minQueryLength = minQueryLength;
        this.isSuggestionFormatHtml = isSuggestionFormatHtml;
        this.showSuggestionsOnSearchFieldClick = showSuggestionsOnSearchFieldClick !== false;
        this.timer = new fmko_ts_common_1.FunctionalTimer(this.onTimerTriggered.bind(this));
        if (searchInitially) {
            this.timer.schedule();
        }
    }
    setValue(newValue, fireEvents = false) {
        super.setValue(newValue, fireEvents);
        if (!newValue && !fireEvents) {
            this.populateSuggestions([], false);
        }
        for (const anchoredButton of this.anchoredButtons) {
            anchoredButton.setEnabled(!!newValue);
        }
    }
    getValue() {
        return this.isOutOfSync() ? undefined : super.getValue();
    }
    isOutOfSync() {
        // Out-of-sync means: User has walked away from this widget with some text in the input field that doesn't match
        // the current value.
        return this.value && this.format(this.value).text !== this.fieldElement.value;
    }
    formatSuggestion(suggestion) {
        return this.format(suggestion);
    }
    isShowingSuggestions() {
        return this.showingSuggestions;
    }
    addBlurHandler(handler) {
        if (!this.blurHandlers) {
            this.blurHandlers = [];
        }
        this.blurHandlers.push(handler);
    }
    getMinQueryLength() {
        return this.minQueryLength;
    }
    setMinQueryLength(minQueryLength) {
        this.minQueryLength = minQueryLength;
    }
    reset() {
        while (this.suggestionsList.firstChild) {
            this.suggestionsList.removeChild(this.suggestionsList.firstChild);
        }
        this.value = undefined;
        this.currentSelectionIndex = -1;
        this.currentLiHighlightedLi = undefined;
        this.suggestions = [];
        this.suggestionsElements = [];
        this.optionToIndexMap.clear();
        this.moreSuggestions = false;
        this.fieldElement.value = "";
        this.textFieldValueStr = "";
        this.fieldImage.setVisible(false);
        const valueChangeEvent = new fmko_ts_common_1.ValueChangeEvent(this.value, false);
        this.fireEvent(valueChangeEvent);
    }
    getCurrentSelectionIndex() {
        return this.currentSelectionIndex;
    }
    hideSuggestions() {
        (0, fmko_ts_common_1.setElementVisible)(this.suggestionsList, false);
        this.showingSuggestions = false;
        this.fieldElement.setAttribute(fmko_ts_common_1.ARIA.EXPANDED, "false");
        this.suggestionsList.classList.remove("animation-ready");
        window.removeEventListener("scroll", this.scrollListener, true);
    }
    getClearButton() {
        return this.clearButton;
    }
    setEnabled(enabled) {
        super.setEnabled(enabled);
        (0, fmko_ts_common_1.setEnabled)(this.element, enabled);
        this.clearButton.setEnabled(enabled);
    }
    addButton(button) {
        if (this.lastButton) {
            fmko_ts_common_1.DOM.insertElementAfter(button.element, this.lastButton.element);
        }
        else {
            fmko_ts_common_1.DOM.insertElementAfter(button.element, this.fieldAndDropdownElement);
        }
        button.element.classList.add("left-anchored-element");
        this.anchoredButtons.push(button);
        this.lastButton = button;
    }
    decorateLabeledInputFieldWithImageWidgetElement(args) {
        const { fieldSizeClass } = args;
        this.anchoredButtons = [];
        const ulId = fmko_ts_common_1.GlobalCounter.next();
        this.fieldElement.autocomplete = "off";
        this.fieldElement.spellcheck = false;
        this.fieldElement.setAttribute("role", fmko_ts_common_1.ARIARole.COMBO_BOX);
        this.fieldElement.setAttribute(fmko_ts_common_1.ARIA.AUTOCOMPLETE, "list");
        this.fieldElement.setAttribute(fmko_ts_common_1.ARIA.CONTROLS, ulId);
        const imageInputElement = this.element;
        this.element = document.createElement("div");
        this.element.classList.add("search-field-element");
        this.fieldAndDropdownElement = document.createElement("div");
        if (fieldSizeClass === FieldSize_1.FieldSize.MAX) {
            this.fieldAndDropdownElement.classList.add(fieldSizeClass);
        }
        this.suggestionsList = document.createElement("ul");
        this.suggestionsList.id = ulId;
        this.suggestionsList.setAttribute("role", fmko_ts_common_1.ARIARole.LIST_BOX);
        this.fieldElement.setAttribute(fmko_ts_common_1.ARIA.EXPANDED, "false");
        this.suggestionsList.classList.add("search-suggestions");
        this.suggestionsList.addEventListener("mousedown", event => {
            event.preventDefault(); // Make sure input doesn't lose focus
        });
        (0, fmko_ts_common_1.setElementVisible)(this.suggestionsList, false);
        this.showingSuggestions = false;
        this.fieldImage = new ImageWidget_1.default({
            alt: "",
            src: ""
        });
        this.fieldImage.setVisible(false);
        imageInputElement.insertBefore(this.fieldImage.element, this.fieldElement);
        this.fieldAndDropdownElement.appendChild(imageInputElement);
        this.fieldAndDropdownElement.appendChild(this.suggestionsList);
        this.fieldAndDropdownElement.classList.add("image-input-and-dropdown");
        this.add(this.fieldAndDropdownElement);
        this.clearButton = new StyledButton_1.default({
            animateHover: false,
            clickHandler: () => {
                this.reset();
            },
            text: "Nulstil"
        });
        this.clearButton.setEnabled(false);
        this.addButton(this.clearButton);
        this.addListeners();
        this.fieldElementContainer = this.element;
        this.decorateLabeledSearchFieldWidgetElement(args);
    }
    onQueryStringChanged() {
        // Template method, for subclasses to override
    }
    populateSuggestions(suggestions, showSuggestions, moreSuggestions = false) {
        this.suggestions = suggestions || [];
        this.moreSuggestions = moreSuggestions;
        this.fieldImage.setVisible(false);
        while (this.suggestionsList.firstChild) {
            this.suggestionsList.removeChild(this.suggestionsList.firstChild);
        }
        this.currentSelectionIndex = -1;
        this.currentLiHighlightedLi = undefined;
        this.suggestionsElements = [];
        this.optionToIndexMap.clear();
        if (moreSuggestions) {
            const hint = document.createElement("li");
            hint.setAttribute("role", fmko_ts_common_1.ARIARole.PRESENTATION);
            hint.classList.add("hint", "first");
            hint.innerText = "Viser ikke alle - præcisér din søgning";
            this.suggestionsList.appendChild(hint);
        }
        for (let i = 0; i < suggestions.length; i++) {
            const suggestion = suggestions[i];
            const listItem = document.createElement("li");
            listItem.id = fmko_ts_common_1.GlobalCounter.next();
            listItem.setAttribute("role", fmko_ts_common_1.ARIARole.OPTION);
            listItem.setAttribute(fmko_ts_common_1.ARIA.SELECTED, "false");
            const { text, image } = this.formatSuggestion(suggestion);
            if (this.isSuggestionFormatHtml) {
                listItem.innerHTML = fmko_ts_common_1.HTMLUtils.sanitizeHTML(text);
            }
            else {
                listItem.textContent = text;
            }
            if (image) {
                listItem.style.setProperty("--search-field-bg-image", `url(${image.src})`);
                listItem.dataset.hasImage = "";
                listItem.setAttribute(fmko_ts_common_1.ARIA.LABEL, `${image.alt}. ${listItem.textContent}`);
            }
            else {
                listItem.style.removeProperty("--search-field-bg-image");
                delete listItem.dataset.hasImage;
                listItem.removeAttribute(fmko_ts_common_1.ARIA.LABEL);
            }
            listItem.addEventListener("mouseover", () => {
                if (DropdownUtil_1.default.dateHasPassedThreshold(this.lastScrollDate)) {
                    this.highlight(listItem);
                }
            });
            listItem.addEventListener("click", event => {
                event.preventDefault(); // Make sure input doesn't lose focus
                this.highlight(listItem);
                if (this.isShowingSuggestions() && this.currentLiHighlightedLi) {
                    this.hideSuggestions();
                    this.select(this.optionToIndexMap.get(listItem));
                }
            });
            if (i === 0) {
                this.currentLiHighlightedLi = listItem;
                this.highlight(this.currentLiHighlightedLi);
            }
            this.suggestionsElements.push(listItem);
            this.optionToIndexMap.set(listItem, i);
            this.suggestionsList.appendChild(listItem);
        }
        if (suggestions.length === 0) {
            const hint = document.createElement("li");
            hint.setAttribute("role", fmko_ts_common_1.ARIARole.PRESENTATION);
            hint.classList.add("hint", "first");
            hint.innerText = "Søgningen gav ingen resultater...";
            this.suggestionsList.appendChild(hint);
        }
        if (showSuggestions) {
            this.showSuggestions(true);
        }
        else {
            this.hideSuggestions();
        }
    }
    parseFieldElementValue(value) {
        // Not used, hence always return null to keep TS-compiler happy!
        return null;
    }
    setFieldElementValue(newValue) {
        if (!newValue) {
            this.fieldElement.value = "";
            return;
        }
        if (this.suggestions && this.suggestions.includes(newValue)) {
            this.currentSelectionIndex = this.suggestions.indexOf(newValue);
            this.highlight(this.suggestionsElements[this.currentSelectionIndex]);
        }
        else {
            this.populateSuggestions([newValue], false, false);
            this.select(0);
        }
        const { text, image } = this.format(newValue);
        this.textFieldValueStr = text;
        this.fieldElement.value = this.textFieldValueStr;
        if (image) {
            this.fieldImage.setSrc(image.src);
            this.fieldImage.setAlt(image.alt);
            this.fieldImage.setVisible(true);
        }
        else {
            this.fieldImage.setVisible(false);
        }
    }
    onTimerTriggered() {
        const query = this.fieldElement.value;
        if (query.length < this.minQueryLength) {
            this.populateSuggestions([], false, false);
        }
        else {
            this.search(query);
            this.fieldImage.setVisible(false);
        }
    }
    showSuggestions(scrollToTop) {
        (0, fmko_ts_common_1.setElementVisible)(this.suggestionsList, true);
        this.renderTopOrBottom();
        if (scrollToTop) {
            this.suggestionsList.scrollTop = 0;
        }
        this.showingSuggestions = true;
        this.lastScrollDate = new Date();
        this.fieldElement.setAttribute(fmko_ts_common_1.ARIA.EXPANDED, "true");
        this.suggestionsList.classList.add("animation-ready");
        window.addEventListener("scroll", this.scrollListener, true);
    }
    select(selectionIndex) {
        if (this.currentSelectionIndex > -1) {
            const currentLi = this.suggestionsElements[this.currentSelectionIndex];
            currentLi.setAttribute(fmko_ts_common_1.ARIA.SELECTED, "false");
        }
        this.currentSelectionIndex = selectionIndex;
        if (this.currentSelectionIndex > -1) {
            const newLi = this.suggestionsElements[this.currentSelectionIndex];
            newLi.setAttribute(fmko_ts_common_1.ARIA.SELECTED, "true");
        }
        this.setValue(this.suggestions[selectionIndex], true);
    }
    handleOnKeyDown(event) {
        let element = undefined;
        if (!this.suggestions.length) {
            return;
        }
        if (!KeyCode.hasModifierKey(event) && this.currentLiHighlightedLi) {
            if (KeyCode.isArrowDown(event)) {
                element = this.findEnabledAdjacentSibling(this.currentLiHighlightedLi, "next");
            }
            else if (KeyCode.isArrowUp(event)) {
                element = this.findEnabledAdjacentSibling(this.currentLiHighlightedLi, "previous");
            }
            else if (KeyCode.isHome(event)) {
                element = DropdownUtil_1.default.getOptionIndexMapKeys(this.optionToIndexMap)[0];
            }
            else if (KeyCode.isEnd(event)) {
                element = DropdownUtil_1.default.getOptionIndexMapKeys(this.optionToIndexMap)[this.suggestions.length - 1];
            }
            if (element) {
                event.preventDefault();
                if (!this.isShowingSuggestions()) {
                    this.showSuggestions(false);
                }
                this.highlight(element);
                this.scrollIntoView(element);
            }
        }
        if (KeyCode.isTab(event) && this.isShowingSuggestions()) {
            this.hideSuggestions();
            event.stopPropagation();
        }
    }
    handleOnKeyUp(event) {
        if (KeyCode.isEscape(event) && this.isShowingSuggestions()) {
            this.hideSuggestions();
            this.reset();
            event.stopPropagation();
            return;
        }
        else if (KeyCode.isEnter(event)) {
            if (this.isShowingSuggestions()) {
                if (this.currentLiHighlightedLi) {
                    this.hideSuggestions();
                    this.select(this.optionToIndexMap.get(this.currentLiHighlightedLi));
                }
                else if (this.suggestions?.length === 1) {
                    this.hideSuggestions();
                    this.select(0);
                }
            }
            else {
                this.showSuggestions(false);
            }
            return;
        }
        const input = event.target;
        const newValue = input.value;
        if (!this.textFieldValueStr || this.textFieldValueStr !== newValue) {
            this.textFieldValueStr = newValue;
            this.timer.schedule(LabeledSearchFieldWidget.SEARCH_TIMER);
            this.onQueryStringChanged();
        }
    }
    addListeners() {
        this.fieldElement.addEventListener("keydown", (event) => {
            this.handleOnKeyDown(event);
        });
        this.fieldElement.addEventListener("keyup", event => {
            this.handleOnKeyUp(event);
        });
        if (this.showSuggestionsOnSearchFieldClick) {
            this.fieldElement.addEventListener("click", () => {
                if (!this.isShowingSuggestions() && this.suggestions.length > 0) {
                    this.showSuggestions(false);
                }
            });
        }
        this.fieldElement.addEventListener("blur", (event) => {
            if (this.isShowingSuggestions()) {
                this.hideSuggestions();
                if (this.suggestions && this.suggestions.length === 1) {
                    this.select(0);
                }
            }
            if (this.blurHandlers) {
                for (let handler of this.blurHandlers) {
                    handler(event);
                }
            }
            if (this.isOutOfSync()) {
                this.setValue(undefined, true);
            }
        });
        this.fieldElement.addEventListener("focus", () => {
            const value = this.fieldElement.value;
            if (value && value.length > 0) {
                this.fieldElement.select();
                this.showSuggestions(false);
            }
        });
    }
    scrollIntoView(element) {
        if (element) {
            const index = this.optionToIndexMap.get(element);
            if (typeof index === "number") {
                const previousSibling = element.previousElementSibling;
                if (previousSibling instanceof HTMLLIElement
                    && previousSibling.getAttribute("role") === fmko_ts_common_1.ARIARole.PRESENTATION) {
                    element = previousSibling;
                }
                element.scrollIntoView({
                    block: "nearest"
                });
                // FMKGUI-329, Det Første element i dropdowns bliver ikke fokuseret. Hvis man går ned på det for hurtigt
                this.lastScrollDate = new Date();
            }
        }
    }
    highlight(newLi) {
        if (this.currentLiHighlightedLi) {
            this.fieldElement.removeAttribute(fmko_ts_common_1.ARIA.ACTIVE_DESCENDANTS);
            this.currentLiHighlightedLi.classList.remove("dropdown-li-highlighted");
            this.currentLiHighlightedLi = undefined;
        }
        this.currentLiHighlightedLi = newLi;
        if (newLi) {
            this.fieldElement.setAttribute(fmko_ts_common_1.ARIA.ACTIVE_DESCENDANTS, newLi.id);
            newLi.classList.add("dropdown-li-highlighted");
        }
    }
    renderTopOrBottom() {
        this.suggestionsList.classList.remove("render-dropdown-on-top");
        const isDropdownFullyVisible = fmko_ts_common_1.DOM.isElementFullyVisible(this.suggestionsList);
        if (!isDropdownFullyVisible) {
            this.suggestionsList.classList.add("render-dropdown-on-top");
        }
    }
    findEnabledAdjacentSibling(element, direction, originalElement) {
        if (element === originalElement) {
            return originalElement; // We have iterated through the entire list of children
        }
        const relevantOriginalElement = originalElement || element;
        const adjacentIndex = direction === "previous" ? -1 : 1;
        const optionIndex = this.optionToIndexMap.get(element);
        const nextIndex = optionIndex + adjacentIndex;
        let adjacentElement;
        if (nextIndex > -1) {
            // Either the element is next in the array, or we are at this.optionElements.length, thus we have to reset to 0
            adjacentElement = DropdownUtil_1.default.getOptionIndexMapKeys(this.optionToIndexMap)[nextIndex % this.suggestions.length];
        }
        else {
            // If we are -1, then we need to go to the end again
            adjacentElement = DropdownUtil_1.default.getOptionIndexMapKeys(this.optionToIndexMap)[this.suggestions.length - 1];
        }
        return this.getElementOrFindAdjacent(direction, adjacentElement, relevantOriginalElement);
    }
    getElementOrFindAdjacent(direction, element, originalElement) {
        if (element) {
            if (!element.hasAttribute("disabled")) {
                return element;
            }
            else {
                // If it's the first recursion then add element as original element
                this.findEnabledAdjacentSibling(element, direction, originalElement);
            }
        }
    }
}
LabeledSearchFieldWidget.SEARCH_TIMER = 400;
exports.default = LabeledSearchFieldWidget;
//# sourceMappingURL=LabeledSearchFieldWidget.js.map